/*
 * Color group — AJAX-переключение между товарами-братьями (каждый цвет = отдельный товар).
 * Клик по свотчу на PDP подменяет секцию товара через Section Rendering API и
 * меняет URL без перезагрузки. Без JS / при ошибке — обычный переход по ссылке.
 *
 * Связи берутся из метаобъекта custom.color_group (см. snippets/color-group-swatches.liquid).
 */
(function () {
  if (window.__colorGroupInit) return;
  window.__colorGroupInit = true;

  // Стили секции подключены через stylesheet_tag ВНУТРИ секции (в <body>).
  // При innerHTML-свопе они бы удалялись → FOUC (контент мелькает нестилизованным,
  // особенно под медленной сетью). Переносим их в <head> один раз — там они переживут своп.
  function hoistSectionStyles(wrapperId) {
    var wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;
    wrapper.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      document.head.appendChild(link);
    });
  }

  function documentHasStylesheet(href) {
    if (!href) return true; // нет href — нечего грузить
    var links = document.querySelectorAll('head link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].href === href) return true;
    }
    return false;
  }

  // Notify Me (Hengam Restock, кнопка «Remind me» для sold-out вариантов):
  // конфиг приложения (_ReStockConfig) рендерится его app embed'ом ВНЕ свопаемых
  // секций, а виджет держит товар в замыкании с момента загрузки страницы. После
  // свопа цвета SDK работал бы с данными старого товара (кнопка для чужих вариантов,
  // подписка не на тот товар). Лечение — полный перезапуск SDK:
  //   1) вычищаем UI старого инстанса (порталы + корневые div'ы в body);
  //   2) обновляем _ReStockConfig свежим инлайн-скриптом из ответа;
  //   3) сбрасываем boot-guard (data-restock-alerts-status="loaded") и подключаем
  //      sdk.js заново — новый инстанс стартует уже с данными нового товара.
  // Если что-то из этого не удалось, страхует кнопка .notify-fallback в main-product.
  function refreshNotifyMeApp(doc) {
    if (!window._ReStockConfig) return; // приложение не установлено / не активно

    document.querySelectorAll('.nm-portal').forEach(function (portal) { portal.remove(); });
    Array.prototype.slice.call(document.body.children).forEach(function (el) {
      // injectElement приложения создаёт в body голые <div> без атрибутов
      if (el.tagName === 'DIV' && !el.id && !el.className &&
          el.querySelector('[class*="restock"], [class*="nm-"], .notifyButtonStyle')) {
        el.remove();
      }
    });

    var scripts = Array.prototype.filter.call(
      doc.querySelectorAll('script:not([src])'),
      function (s) { return s.textContent.indexOf('_ReStockConfig.product') !== -1; }
    );
    if (!scripts.length) return;
    // Скриптов с упоминанием конфига может быть несколько — сам конфиг самый большой.
    var freshConfig = scripts.sort(function (a, b) { return b.textContent.length - a.textContent.length; })[0];
    try {
      new Function(freshConfig.textContent)(); // присваивания обновляют window._ReStockConfig на месте
    } catch (e) {
      return; // конфиг не обновился — перезапускать SDK со старыми данными нельзя
    }

    var sdkScript = document.querySelector('script[src*="cdn.notify-me.io/sdk.js"]');
    if (sdkScript) {
      delete document.documentElement.dataset.restockAlertsStatus;
      var freshSdk = document.createElement('script');
      freshSdk.src = sdkScript.src;
      document.body.appendChild(freshSdk);
    } else {
      // sdk.js не нашли (сменили CDN?) — хотя бы переинициализируем сервисы конфига
      document.dispatchEvent(new CustomEvent('nm-config-changed'));
    }
  }

  // Убирает дубли модалок, которые ModalDialog.connectedCallback() переносит в <body>.
  // Группируем по id (или тегу) и оставляем последнюю — она соответствует текущему товару.
  // Часть id несёт id секции шаблона (ProductModal-template--123__main), а шаблоны у
  // товаров-братьев разные — нормализуем, иначе дубли не схлопнутся.
  function dedupeHoistedModals() {
    var groups = {};
    document.querySelectorAll('body > modal-dialog, body > product-modal').forEach(function (el) {
      var key = (el.id || el.tagName).replace(/template--\d+__/, 'template__');
      (groups[key] = groups[key] || []).push(el);
    });
    Object.keys(groups).forEach(function (key) {
      var list = groups[key];
      for (var i = 0; i < list.length - 1; i++) list[i].remove();
    });
  }

  // innerHTML не исполняет вставленные <script>. Для второстепенных секций
  // (our-community и т.п.) переисполняем их инлайн-скрипты вручную.
  // ВАЖНО: для main-product этого делать нельзя — там инлайновое объявление
  // class SliderPromo, повторное исполнение бросит SyntaxError; его скрипты
  // переинициализируются по событию color-group:loaded.
  function reexecuteInlineScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      if (old.src) return;
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript') return; // JSON/ld+json не трогаем
      var fresh = document.createElement('script');
      // Оборачиваем в IIFE: top-level const/let/class из скрипта секции уже
      // объявлены первым исполнением при загрузке страницы — повторное
      // объявление в глобальном скоупе бросило бы SyntaxError.
      fresh.textContent = '(function () {\n' + old.textContent + '\n})();';
      old.replaceWith(fresh);
    });
  }

  async function swap(url, wrapperId, push) {
    var mainWrapper = document.getElementById(wrapperId);
    if (!mainWrapper) {
      window.location.href = url;
      return;
    }
    var sectionId = wrapperId.replace(/^shopify-section-/, '');
    mainWrapper.classList.add('color-group-loading');
    try {
      // Тянем ПОЛНУЮ страницу товара: обновляем не только main-product, но и
      // остальные секции шаблона (our-community, отзывы, рекомендации) —
      // они зависят от товара и иначе показывали бы контент старого цвета.
      var res = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var text = await res.text();
      var doc = new DOMParser().parseFromString(text, 'text/html');

      // У товаров-братьев могут быть РАЗНЫЕ шаблоны (product.*.json на каждый
      // цвет) → id секций различаются (template--A__main vs template--B__main).
      // Сопоставляем по суффиксу за последним «__» (main, our-community, …).
      var sectionKey = function (id) {
        return (id || '').split('__').pop();
      };
      var freshByKey = {};
      doc.querySelectorAll('#MainContent .shopify-section').forEach(function (s) {
        var key = sectionKey(s.id);
        if (!(key in freshByKey)) freshByKey[key] = s;
      });

      var freshMain = freshByKey[sectionKey(wrapperId)];
      if (!freshMain) throw new Error('main section not found in response');
      var freshMainId = freshMain.id;

      document.querySelectorAll('#MainContent .shopify-section').forEach(function (section) {
        var fresh = freshByKey[sectionKey(section.id)];
        if (!fresh) return; // у нового шаблона нет такой секции — не трогаем
        // Контент не изменился — пропускаем: сохраняем живые слушатели и не
        // дёргаем лишние реинициализации. Сравниваем с нормализацией id
        // шаблона (template--A__ vs template--B__), иначе одинаковые секции
        // разных шаблонов (newsletter) свапались бы напрасно.
        var normalize = function (html) {
          return html.replace(/template--\d+__/g, 'template__');
        };
        if (normalize(fresh.innerHTML) === normalize(section.innerHTML)) return;

        // Сначала переносим в <head> текущие стили секции (вкл. добавленные
        // блоками после инициализации) — чтобы своп их не удалил → без FOUC.
        hoistSectionStyles(section.id);

        // Стили из ответа: дублирующие <link> вырезаем, реально новые — в <head>.
        fresh.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
          if (documentHasStylesheet(link.href)) {
            link.remove();
          } else {
            document.head.appendChild(link);
          }
        });

        // Меняем обёртку целиком (replaceWith, не innerHTML): новая секция несёт
        // СВОЙ id шаблона, а внутренняя разметка (data-section-id, формы) на него
        // ссылается — иначе следующий клик по цвету не нашёл бы свою секцию.
        var isMain = section.id === wrapperId;
        var node = document.importNode(fresh, true);
        section.replaceWith(node);
        if (!isMain) reexecuteInlineScripts(node);
      });

      // Модалки (size-guide, media-lightbox) сами переносятся в <body> в connectedCallback,
      // поэтому при свопе накапливаются дубли. Оставляем по одной (самой свежей) на id/тег.
      dedupeHoistedModals();

      refreshNotifyMeApp(doc);
      // Маркер «товар подменён без перезагрузки» — по нему main-product решает
      // показывать свой notify-фолбэк вместо мёртвого виджета приложения.
      document.documentElement.setAttribute('data-color-group-swapped', '');

      if (doc.title) document.title = doc.title;

      if (push) history.pushState({ colorGroup: true }, '', url);

      // Okendo (отзывы): сервер отдаёт «сырую» разметку (огромные звёзды),
      // которую гидрирует скрипт Okendo при загрузке страницы. После свопа
      // вставленные виджеты (звёздный бейдж у цены, блок отзывов) надо
      // переинициализировать вручную, иначе остаются сырые звёзды.
      if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function') {
        document.querySelectorAll('[data-oke-star-rating], [data-oke-widget]').forEach(function (el) {
          window.okeWidgetApi.initWidget(el);
        });
      }

      // Переинициализация не-custom-element скриптов main-секции (напр. SliderPromo).
      // НЕ диспатчим shopify:section:load — это «редакторное» событие, на него реагируют
      // сторонние аппы/скрипты и могут показывать лишние оверлеи.
      document.dispatchEvent(new CustomEvent('color-group:loaded', { detail: { sectionId: freshMainId.replace(/^shopify-section-/, '') } }));
    } catch (e) {
      // Любая ошибка — безопасный полный переход
      window.location.href = url;
      return;
    } finally {
      mainWrapper.classList.remove('color-group-loading');
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.color-group--pdp a[data-product-url]');
    if (!link) return;

    var container = link.closest('[data-color-group]');
    var wrapperId = container && container.dataset.sectionId;
    if (!wrapperId) return; // нет id секции — пусть отработает обычная ссылка

    e.preventDefault();
    if (link.classList.contains('is-selected')) return; // уже на этом цвете

    swap(link.dataset.productUrl, wrapperId, true);
  });

  window.addEventListener('popstate', function () {
    var cg = document.querySelector('.color-group--pdp[data-section-id]');
    if (!cg) return;
    swap(window.location.pathname + window.location.search, cg.dataset.sectionId, false);
  });

  // На старте переносим стили секции в <head>, чтобы своп их не удалял
  function init() {
    var cg = document.querySelector('.color-group--pdp[data-section-id]');
    if (cg) hoistSectionStyles(cg.dataset.sectionId);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
